module.exports = {"conductor":"Condutor","currency":"R$","licensePlate":"Placa","subtotal":"Subtotal","vehicle":"Veículo"}


//////////////////
// WEBPACK FOOTER
// ./src/app/elements/InvoiceDetailsVehicle/data.json
// module id = 2067
// module chunks = 0